"use client";

import { useEffect, useState } from "react";
import Script from "next/script";

// El banner de cookies lo instala Landing Agency desde GTM (cookieconsent 3.1.1).
// Guarda la elección en la cookie `cookieconsent_status` (allow | deny) y avisa
// con el evento `cc_consent_update` (con `cc_status`) en el dataLayer. Meta,
// Google Ads y GA4 no se cargan hasta que el visitante acepta.
const CONSENT_COOKIE = "cookieconsent_status";
const CONSENT_EVENT = "cc_consent_update";

const META_PIXEL_ID = "1097542230955158";
const GOOGLE_ADS_ID = "AW-11236317649";
const GA4_ID = "G-4DTWM1BCFY";

type DataLayerEntry = { event?: string; cc_status?: string } & Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerEntry[];
  }
}

function hasConsent(): boolean {
  return document.cookie
    .split("; ")
    .some((c) => c === `${CONSENT_COOKIE}=allow`);
}

export function ConsentedTags() {
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (hasConsent()) {
      setAllowed(true);
      return;
    }

    const dataLayer = (window.dataLayer = window.dataLayer || []);
    const isAllow = (e: DataLayerEntry) =>
      e?.event === CONSENT_EVENT && e.cc_status === "allow";

    if (dataLayer.some(isAllow)) setAllowed(true);

    // GTM encadena el push original, así que esto sigue funcionando se cargue
    // antes o después que el contenedor.
    const originalPush = dataLayer.push;
    dataLayer.push = function (...entries: DataLayerEntry[]) {
      const result = originalPush.apply(this, entries);
      if (entries.some(isAllow)) setAllowed(true);
      return result;
    };

    return () => {
      dataLayer.push = originalPush;
    };
  }, []);

  if (!allowed) return null;

  return (
    <>
      {/* Meta Pixel Code */}
      <Script id="meta-pixel" strategy="afterInteractive">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${META_PIXEL_ID}');
          fbq('track', 'PageView');
        `}
      </Script>
      {/* Google tag (gtag.js) - Google Ads y GA4 */}
      <Script
        id="gtag-src"
        src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`}
        strategy="afterInteractive"
      />
      <Script id="gtag-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GOOGLE_ADS_ID}');
          gtag('config', '${GA4_ID}');
        `}
      </Script>
    </>
  );
}
